import { notification } from 'antd';

import apiDatalake from '../services/apiDatalake';
import apiNetCore from '../services/apiNetCore';

export const searchProdutos = async (
  value,
  setProdutos,
  setLoadingProdutos
) => {
  if (!value || value.length < 3) return;

  setProdutos([]);
  try {
    setLoadingProdutos(true);
    const response = await apiDatalake.get(`/api-produto?nome=${value}`);
    setProdutos(Array.isArray(response.data) ? response.data : []);
  } catch (err) {
    notification.error({
      message: 'Ops, não conseguimos buscar os produtos.',
      description:
        'Caso o problema persista, entre em contato com nosso suporte.',
    });
  } finally {
    setLoadingProdutos(false);
  }
};

export const searchProdutosAts = async (
  value,
  setProdutos,
  setLoadingProdutos
) => {
  if (!value || value.length < 3) return;

  setProdutos([]);
  try {
    setLoadingProdutos(true);
    const { data } = await apiNetCore.get(
      `/ProdutoAts/ConsultarProdutosDescricao?descricao=${value}`
    );

    setProdutos(Array.isArray(data.data) ? data.data : []);
  } catch (err) {
    notification.error({
      message: 'Ops, não conseguimos buscar os produtos.',
      description:
        'Caso o problema persista, entre em contato com nosso suporte.',
    });
  } finally {
    setLoadingProdutos(false);
  }
};

export const searchProdutosByClientePagador = async (
  value,
  setProdutos,
  setLoadingProdutos
) => {
  setProdutos([]);
  try {
    setLoadingProdutos(true);
    const { data } = await apiNetCore.post(
      '/ProdutoAts/GetTodosProdutosPorClienteForUiGrid',
      {
        Filters: [
          {
            Campo: 'IdCliente',
            Operador: 8,
            Valor: value,
            CampoTipo: 2,
          },
          {
            Campo: 'Ativo',
            Operador: 8,
            Valor: 1,
            CampoTipo: 2,
          },
        ],
        Page: 1,
        Take: 694,
        Order: { Campo: 'Descricao', Operador: 0 },
      }
    );

    setProdutos(Array.isArray(data.data.items) ? data.data.items : []);
  } catch (err) {
    notification.error({
      message: 'Ops, não conseguimos buscar os produtos.',
      description:
        'Caso o problema persista, entre em contato com nosso suporte.',
    });
  } finally {
    setLoadingProdutos(false);
  }
};
